import * as React from 'react';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BUILDING_MANAGER } from '../../constants';

export default function ({ building }) {
  const hasRole = building.Roles.includes(BUILDING_MANAGER);
  const { t } = useTranslation();

  if (!hasRole) {
    return null;
  }

  return (
    <Button
      to={`/app/buildings/${building.id}/users`}
      component={Link}
      variant="outlined"
      color="primary"
      size="small"
      fullWidth
      style={{ marginTop: '5px' }}
    >
      {t('Users')}
    </Button>
  );
}
